import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
} from "./actionTypes";

const initialState = {
  error: "",
  loading: false,
  user: null,
  isUserLogout: false,
};

const login = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_USER:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        user: action.payload,
        error: "",
        isUserLogout: false,
      };
    case LOGOUT_USER:
      return { 
        ...state, 
        isUserLogout: false 
      };
    case LOGOUT_USER_SUCCESS:
      return { 
        ...state, 
        isUserLogout: true,
        user: null 
      };
    case API_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
        isUserLogout: false,
      };
    default:
      return state;
  }
};

export default login;